import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
import { useMountEffect } from "app/utils/hooks";
import "./Profile.scss";
import Information from "../Information/Information";
import Authorities from "../Authorities/Authorities";
import Assignments from "../Assignments/Assignments";
import Preferences from "../Preferences/Preferences";
import Expirations from "../Expirations/Expirations";
const Profile = () => {
  const expirationHeaders = {
    typeOfEExpirations: "Type of Expirations",
    idNumber: "Id Number",
    expirations: "Expiration",
    status: ["Status"],
  };
  const expirationData = [
    {
      typeOfEExpirations: "Driver License ",
      idNumber: "KJH324H323",
      expirations: "22 Jan, 2023",
      status: ["Expired", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "TWIC Card",
      idNumber: "JHG342J4234234J34234",
      expirations: "3 Apr, 2023",
      status: ["Expired", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Passport",
      idNumber: "JB3243JK2",
      expirations: "12 Mar, 2026",
      status: ["Active", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Medical Certificate",
      idNumber: "BH32423",
      expirations: "18 Dec 2028",
      status: ["Active", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Drug & Alcohol Document",
      idNumber: "NIU324HIU32H4U",
      expirations: "15 Oct 2023",
      status: ["Suspended", "Claimed", "Claimed"],
    },
    {
      typeOfEExpirations: "Skill Performance Evaluation Certificate",
      idNumber: "BH32J423434",
      expirations: "12 Jan 2030",
      status: ["Suspended", "Claimed", "Claimed"],
    },
  ];
  return (
    <>
      {/* Information*/}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle" style={{ marginTop: "0" }}>
            <CardBody>
              <Information />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Authorities */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <Authorities />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Preferences */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <Assignments />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Preferences */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <Preferences />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Expirations */}
      <Row xl={12} md={12} sm={12} xs={12}>
        <Col xl={12} md={12} sm={12} xs={12}>
          <Card className="cardStyle">
            <CardBody>
              <Expirations headers={expirationHeaders} data={expirationData} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default Profile;
